module.exports = __webpack_public_path__ + "img/roll.28748d7f.webp";